import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import { useOsTheme } from 'naive-ui'

export type ThemeMode = 'system' | 'light' | 'dark'

export const useThemeStore = defineStore('theme', () => {
  const mode = ref<ThemeMode>((localStorage.getItem('bx_theme') as ThemeMode) || 'system')
  const osTheme = useOsTheme()

  const isDark = computed(() => {
    if (mode.value === 'dark') return true
    if (mode.value === 'light') return false
    return osTheme.value === 'dark'
  })

  watch(mode, (m) => localStorage.setItem('bx_theme', m))

  function set(next: ThemeMode): void {
    mode.value = next
  }

  return { mode, isDark, set }
})
